<template>
  <v-app>
    <v-content>
      <contact-form></contact-form>
    </v-content>
  </v-app>
</template>

<script>
import ContactForm from "./components/ContactForm";
export default {
  name: "App",

  components: {
    ContactForm,
  },
};
</script>